/**
 * Zrcadlí odkaz „Administrace" z top baru do mobilního menu.
 *
 * Top bar je pod breakpointem md skrytý (`.top-bar { display: none }`), takže
 * schvalovatel se na mobilu do administrace jinak nedostane.
 *
 * Zdrojový odkaz odmazává backend blokem NOTKLIENT (autologin účty), a protože
 * REDA `_deleteBlock()` používá greedy regex, druhý NOTKLIENT pár v inc-header.tpl
 * by smazal celou hlavičku. Klonování za běhu drží jediný zdroj pravdy: když
 * odkaz v top baru není, nevznikne ani mobilní varianta.
 */
export function initMobileAdminLink() {
  const source = document.getElementById('menu-admin');
  const mobileMenu = document.getElementById('mobileMenu');

  if (!source || !mobileMenu) return;
  if (mobileMenu.querySelector('.nav__link--admin')) return;

  const link = document.createElement('a');
  link.href = source.getAttribute('href');
  link.className = 'nav__link nav__link--admin';
  link.setAttribute('role', 'menuitem');
  link.textContent = source.textContent.trim();

  mobileMenu.prepend(link);
}
